import { customElement} from 'lit/decorators.js';
import { Router } from '@vaadin/router';
import { BernerScreenBase } from './berner-screen-base';
import { LANDING_PAGE } from '../api/ui';

@customElement('berner-start')
export class BernerStart extends BernerScreenBase {
    async firstUpdated(): Promise<void> {
        const initialized = await super.checkInitialized();
        if (initialized) {
            Router.go(LANDING_PAGE);
        }
    }
}
